import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Beginner_friendly_fitnessIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/beginner_friendly_fitness.svg';
import { ReactComponent as Functional_trainingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/functional_training.svg';
import { ReactComponent as Strength_cardio_mixIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_cardio_mix.svg';
import { ReactComponent as Full_body_trainingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_training.svg';

interface GeneralFitnessStep2Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  full_body_training: <Full_body_trainingIcon />,
  functional_training: <Functional_trainingIcon />,
  strength_cardio_mix: <Strength_cardio_mixIcon />,
  beginner_friendly_fitness: <Beginner_friendly_fitnessIcon />,
};

// How should this goal be approached?
// Choose the training type that best suits your client
export const GeneralFitnessStep2: FC<GeneralFitnessStep2Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'general_fitness',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
